import React from "react";
import { Routes, Route } from "react-router-dom";
import App from "./App";
import ContactUs from "./components/ContactUs"; // Create this component
import TermsConditions from "./components/TermsConditions"; // Create this component
import PrivacyPolicy from "./components/PrivacyPolicy"; // Create this component
import CustomerSceen from "./pages/CustomerScreen"; // Create this component
import OnboardingScreen from "./pages/OnboardingScreen"; // Create this component
import CustomerSearch1 from "./components/CustomerSearch1";
import SummaryPage from "./components/SummaryPage";
import RmForm from "./components/RmForm";
import Header from "./components/Header";
import ProtectedRoute from "../src/utility/ProtectedRoute"; // Ensure this is correctly implemented

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<App />} />
    <Route path="/contact-us" element={<ContactUs />} />
    <Route path="/terms-conditions" element={<TermsConditions />} />
    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
    <Route
      path="/customerscreen"
      element={
        <ProtectedRoute>
          <CustomerSceen />
        </ProtectedRoute>
      }
    />
    <Route
      path="/onboardingscreen"
      element={
        <ProtectedRoute>
          <OnboardingScreen />
        </ProtectedRoute>
      }
    />
    <Route
      path="/customersearch1"
      element={
        <ProtectedRoute>
          <CustomerSearch1 />
        </ProtectedRoute>
      }
    />
    <Route
      path="/summarypage"
      element={
        <ProtectedRoute>
          <div>
            <Header />
            <section className="multistep_sec">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12">
                    <div className="menu_link_section">
                      <div className="content_box">
                        <div className="form-card">
                          <div className="row align-items-center">
                            <div className="col-md-12">
                              <SummaryPage />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </ProtectedRoute>
      }
    />
    <Route
      path="/rmFormPage"
      element={
        <ProtectedRoute>
          <div>
            <Header />
            <section className="multistep_sec">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12">
                    <div className="menu_link_section"></div>
                    <div className="content_box">
                      <div className="form-card">
                        <div className="row align-items-center">
                          <div className={"col-md-12"}>
                            <RmForm />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </ProtectedRoute>
      }
    />
  </Routes>
);

export default AppRoutes;
